import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import { ProcessLog } from '@/found/modules';
import Form from './form';
import EditEndTime from './form/edit_end_time.vue';

export default {
  name: 'consumerScan',
  extends: TablePage,
  components: {
    Form,
    ProcessLog,
    EditEndTime,
  },
  data() {
    return {
      requestType: 'POST',
      requestUrl: '/cps-mobile/consumerscanactivitymain/list',
      params: {
      },
      formConfig: {},
      modalConfig: {
      },
      searchFormData: {},
      formData: {},
    };
  },
  async created() {
    await this.getConfigList('consumer_consumerScan_list');
  },
  //   async mounted() {
  //     await this.getPath();
  //   },
  //   deactivated() {
  //     this.formData = {};
  //     this.searchFormData = {};
  //     this.getList();
  //   },
  methods: {
    // setColumn(v) {
    //   const rowData = v;
    //   return rowData;
    // },
    clickVisible({ row, val: { code } }) {
      const {
        processCode,
        processStatus,
      } = row;
      // 审批通过 approved,审批中 approving,活动关闭 closed,流程追回 interrupt,驳回 rejected
      if (code === 'process_log' && !processCode) {
        return false;
      }
      if ((code === 'edit' || code === 'budget_edit') && ['1', '2'].includes(processStatus)) {
        return false;
      }

      // 行按钮显示控制：非启用状态的活动不展示「编辑结束时间」
      if (code === 'edit_end_time') {
        return !!row && row.enableStatus === '009';
      }

      return true;
    },
    modalClick({ val, row }) {
      const { code } = val;
      // 编辑结束时间
      if (code === 'edit_end_time') {
        this.openEditEndTime(row);
        return;
      }
      if (['add', 'edit', 'view', 'copy', 'budget_edit'].includes(code)) {
        this.formConfig = {
          ...this.formConfig,
          code,
          row: {
            ...row,
            id: row.activityCode,
          },
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      }

      if (code === 'copy_activity') {
        // 顶部按钮，row 为当前选中数据集合
        let selectedRows = [];
        if (Array.isArray(row)) {
          selectedRows = row;
        } else if (row) {
          selectedRows = [row];
        }
        // 未选择数据
        if (selectedRows.length === 0) {
          this.$message.warning('请先选择一条数据再进行复制');
          return;
        }
        // 仅允许单选
        if (selectedRows.length > 1) {
          this.$message.warning('复制操作仅支持选择一条数据，请重新选择');
          return;
        }
        const [selectedRow] = selectedRows;
        this.formConfig = {
          ...this.formConfig,
          code: 'copy',
          row: {
            ...selectedRow,
            id: selectedRow.activityCode,
          },
        };
        this.modalConfig.title = val.name || '复制';
        this.openFull();
        return;
      }

      if (val.code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row: { processNo: row.processCode },
        };

        this.modalConfig.title = '流程日志';

        this.formName = 'ProcessLog';
        this.openDrawer();
      }
    },
    // 提交审批回调
    onSubmit(params) {
      const configParams = {
        ...params,
        code: 'approve',
      };

      this.$emit('approve', configParams);
    },
    // 打开「编辑结束时间」弹窗
    openEditEndTime(row) {
      // 只允许修改启用状态的活动
      if (!row || row.enableStatus !== '009') {
        this.$message.warning('只允许修改启用状态的活动');
        return false;
      }
      this.modalConfig.title = '编辑结束时间';
      this.modalConfig.width = '500px';
      this.modalConfig.height = '200px';
      this.modalConfig.type = 'modal';
      this.formName = 'EditEndTime';
      this.formConfig = {
        ...this.formConfig,
        code: 'edit_end_time',
        row,
      };
      this.openModal();
      return true;
    },
    // disable(type) {
    //   let url = '/cps-mobile/consumerscanactivitymain/enable';
    //   if (type) url = '/cps-mobile/consumerscanactivitymain/disable';
    //   request.patch(url, this.selection).then((res) => {
    //     if (!res.success) return this.$message.error(res.message);
    //     this.$message.success(res.message);
    //     this.getList();
    //   });
    // },
    // clickVisible({ val, row }) {
    //   return true;
    // },
    // 监听页面跳转
    // getPath() {
    //   if (Object.keys(this.$route.params).length !== 0) {
    //     this.formData.templateCode = this.$route.params.templateCode;
    //     // this.searchFormData = {
    //     //   ...this.searchFormData,
    //     //   templateCode: this.$route.params.templateCode,
    //     // };
    //     this.searchFormData.templateCode = this.$route.params.templateCode;
    //     this.getList();
    //     // this.searchFormData = {};
    //   }
    // },
  },
//   watch: {
//     $route: 'getPath',
//   },
};
